import * as React from 'react';
import { useHits } from 'react-instantsearch';
import { buildData } from "../../helpers";
import { LinesPreloader } from "../Preloader";
import LineChartWidget from "../LineChartWidget";

export default function HitsWidget({ chartConfig, lineStyle }) {
  const { items } = useHits();

  const { data: chartData, groups: chartGroups } = React.useMemo(
    () => buildData(items, chartConfig),
    [items, chartConfig]
  );

  if (chartData.length === 0 || chartGroups.length === 0) {
    return <LinesPreloader/>;
  }

  return <LineChartWidget chartData={chartData} chartGroups={chartGroups} chartConfig={chartConfig} lineType={lineStyle}/>;
}
